/* eslint-disable */

export const getFromRedis = (key: string): null => null;

export const setToRedis = (
  key: string,
  data: any,
  expires: number = 30,
): void => {};
